var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('entry-write-component',{attrs:{"entry-type":'entry',"competitionKey":_vm.competitionKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }